import { makeStyles } from "@material-ui/core";
import typography from "../../theme/typography";
import palette from "../../theme/palette";

const useStyles = makeStyles((theme) => ({
    background: {
        backgroundColor: "var(--color-new-main)",
        border: "2px solid var(--color-new-main)",
        color: "#fff !important",
        borderRadius: "8px",
        "& p": {
            color: "black !important"
        },
        "& h4": {
            color: "black !important"
        },
        // Dark mode styles
        ".dark-mode &": {
            backgroundColor: "var(--dark-surface-elevated)",
            border: "2px solid var(--dark-border)",
            "& p": {
                color: "var(--dark-text-primary) !important"
            },
            "& h4": {
                color: "var(--dark-text-primary) !important"
            }
        }
    },
    backgroundYesNo: {
        background: '#fff',
        width: '100%',
        height: '34px',
        borderRadius: '20px',
        display: 'flex',
        alignItems: "center",
        justifyContent: 'center',
        padding: "8px 24px 8px 16px",
        gap: "4px",
        // Dark mode styles
        ".dark-mode &": {
            // background: "var(--dark-surface)",
            color: "var(--dark-surface)",
            "& .MuiTypography-root": {
                color: "var(--color-dark-inner) !important"
            }
        }
    },
    rightActiveInverse: {
        background: "#FF5555",
        "& svg": {
            "& path": {
                stroke: `var(--color-black) !important`
            }
        },
        // Dark mode styles
        ".dark-mode &": {
            background: "#d32f2f",
            "& svg": {
                "& path": {
                    stroke: `var(--color-dark-inner) !important`,
                    strokeWidth: "2px",
                }
            }
        }
    },
    rightActive: {
        background: "var(--color-new-main)",
        "& svg": {
            "& path": {
                strokeWidth: "1px",
                stroke: `var(--color-black) !important`
            }
        },
        "& .MuiTypography-root": {
            fontWeight: `600 !important`
        },
        // Dark mode styles
        ".dark-mode &": {
            // background: "var(--dark-surface-elevated)",
            "& svg": {
                "& path": {
                    strokeWidth: "2px",
                    stroke: `var(--color-dark-inner) !important`
                }
            }
        }
    },
    corssActive: {
        background: "#FF5555",
        "& svg": {
            "& path": {
                stroke: `var(--color-black) !important`
            }
        },
        // Dark mode styles
        ".dark-mode &": {
            background: "#d32f2f",
            "& svg": {
                "& path": {
                    strokeWidth: "2px",
                    stroke: `var(--color-dark-inner) !important`
                }
            }
        }
    },
    corssActiveInverse: {
        background: "var(--color-new-main)",
        "& svg": {
            "& path": {
                stroke: `var(--color-black) !important`
            }
        },
        // Dark mode styles
        ".dark-mode &": {
            "& svg": {
                "& path": {
                    strokeWidth: "2px",
                }
            }
        }
    },
    headerBlocks: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "12px 2px 12px 2px",
        height: "56px",
        gap: "4px",
        width: "44px",
        minWidth: "44px",
        "& p": {
            textAlign: "center",
            verticalAlign: "midle"
        },
        "& span": {
            fontWeight: 500,
        },
        // Dark mode styles
    },
    selectionExpanded: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '7px',
        width: '100%',
        // Dark mode styles
        ".dark-mode &": {
            backgroundColor: "transparent",
            color: "var(--dark-text-primary)"
        }
    },
    selection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '16px',
        width: '100%',
        // Dark mode styles
    },
    rectangleInputFull: {
        width: '100%',
        borderRadius: '12px',
        padding: '0px',
        display: 'flex',
        // background: '#F3F3F3',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        position: 'relative',
        // Dark mode styles
        ".dark-mode &": {
            background: "transparent",
            color: "var(--dark-text-primary)",
        }
    },
    rectangleInput: {
        width: '36px',
        height: '36px',
        transform: 'rotate(-90deg)',
        flexShrink: 0,
        borderRadius: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'relative',
        // Dark mode styles
        ".dark-mode &": {
            border: "1px solid var(--dark-border)",

        }
    },
    counterView: {
        lineHeight: "125% !important"
    },
    inputContainer: {
        // padding: "5px",
        borderRadius: "999px",
        flexShrink: 0,
        height: "40px",
        width: "100%",
        display: "flex",
        // alignItems: 'center',
        justifyContent: "center",
        // paddingTop: "8px",
    },
    inputContainerDescription: {
        // padding: "5px",
        borderRadius: "999px",
        flexShrink: 0,
        width: "100%",
        display: "flex",
        gap: "16px",
        // alignItems: 'center',
        justifyContent: "center",
        // paddingTop: "8px",
    },
    rateInput: {
        width: "100%",
        height: "34px",
        outline: "none",
        textAlign: "center",
        border: "none"
    },
    inputContainerFullWidth: {
        flexShrink: 0,
        width: "100%",
        display: "flex",
        // alignItems: 'center',
        justifyContent: "center",
        position: 'relative'
    },
    inputContainerFullWidthDescription: {
        flexShrink: 0,
        width: "100%",
        display: "flex",
        gap: "16px",
        // alignItems: 'center',
        justifyContent: "center",
        position: 'relative'
    },
    inputContainerFullWidthDescriptionWithBorder: {
        padding: "0px 24px",
        borderRadius: `12px`,
        // border: `1px solid var(--color-border)`,
        border: `none`,
    },
    cardBody: {
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: 'column',
        gap: '8px',
        // justifyContent: "space-between",
        padding: "16px",
        borderRadius: "8px",
        // alignItems: "center",
        // marginBottom: "10px",
        // boxShadow: '0px 11px 30px -20px rgba(211, 218, 215, 0.23)',
        borderTop: "1px solid var(--color-border)",
        // Dark mode styles
        ".dark-mode &": {
            backgroundColor: "transparent",
            borderTop: "1px solid var(--dark-border)",
            color: "var(--dark-text-primary)"
        }
    },
    cardBodyNew: {
        display: "flex",
        padding: "16px",
        flexDirection: 'column',
        gap: '16px',
        borderRadius: '0px',
        borderTop: "1px solid var(--color-border)",
        // Dark mode styles
    },
    clock: {
        position: "absolute",
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        color: "var(--color-black)",
        fontWeight: 400,
        height: "34px",
        padding: "8px 16px",
        gap: "4px",
        borderRadius: "20px",
        // Dark mode styles
        ".dark-mode &": {
            color: "var(--dark-text-primary)"
        }
    },
    hand: {
        position: "absolute",
        width: "3px",
        margin: "auto",
        left: "0",
        bottom: "0",
        right: "0",
        backgroundColor: "#fff",
        transformOrigin: "bottom",
        borderRadius: "4px",
        // Dark mode styles
        ".dark-mode &": {
            backgroundColor: "var(--dark-surface-elevated)"
        }
    },
    minute: {
        height: "14px",
        top: "-60%",
    },
    hour: {
        height: "10px",
        top: "-35%",
    },
    plusIcon: {
        fontSize: "42px",
        color: "#E3E3E3",
        fontFamily: typography.fontFamily,
        // marginTop: "8px",
        display: "flex",
        alignItems: "center",
        // Dark mode styles
        ".dark-mode &": {
            color: "var(--dark-text-secondary)"
        }
    },
    notesItem: {
        margin: "0px",
        padding: "0px",
        // marginLeft: '5px',
        listStyleType: "none",
        textAlign: "center",
        lineHeight: "25.6px",
        // paddingLeft: "0",
        // maxHeight: "50px",
        // overflowY: "auto",
        // maxWidth: "170px",
        listStylePosition: "inside",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        "& li": {
            color: palette.primary.light,
            fontSize: "12px",
            lineHeight: "25.6px",
            position: "relative",
            // display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'flex-start',
            margin: "3px 0",
            // Dark mode styles
            ".dark-mode &": {
                color: "var(--dark-text-primary)"
            },
            "&:before": {
                content: "''",
                backgroundColor: palette.primary.main,
                width: "4px",
                height: "4px",
                display: "inline-block",
                marginRight: "5px",
                marginBottom: "2px",
                borderRadius: "50%",
                //     alignSelf: 'flex-start',
                // marginTop: '5px',
            },
            "&::::marker": {
                color: palette.primary.main,
            },
        },
    },
    textAreaClass: {
        "&:focus": {
            fontSize: "16px",
        }
    },
    // Add dark mode specific styles
    darkModeContainer: {
        backgroundColor: "var(--dark-background)",
        color: "var(--dark-text-primary)",
        transition: "all 0.3s ease"
    },
    darkModeCard: {
        backgroundColor: "var(--dark-surface)",
        border: "1px solid var(--dark-border)",
        color: "var(--dark-text-primary)",
        boxShadow: "0 2px 8px var(--dark-shadow)"
    },
    darkModeInput: {
        backgroundColor: "var(--dark-input-background)",
        border: "1px solid var(--dark-input-border)",
        color: "var(--dark-text-primary)",
        "&::placeholder": {
            color: "var(--dark-text-secondary)"
        }
    },
    darkModeButton: {
        backgroundColor: "var(--dark-surface-elevated)",
        color: "var(--dark-text-primary)",
        border: "1px solid var(--dark-border)",
        "&:hover": {
            backgroundColor: "var(--dark-surface)"
        }
    }
}));

export default useStyles